export function selectNewSequenceInGroup(state, payload) {
  return {
    ...state,
    currentSection: setSelectionInCurrentSection(state.currentSection, payload),
  };
}

function setSelectionInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: setSelectionInComponents(currentSection.components, payload),
  };
}

function setSelectionInComponents(components, payload) {
  return components.map((component) => {
    if (component.id === payload.componentID) {
      component = setSelectionInComponent(component, payload);
    }
    return component;
  });
}

function setSelectionInComponent(component, payload) {
  return {
    ...component,
    sliderGroups: setSelectionInSliderGroups(component.sliderGroups, payload),
    showFeedback: false,
  };
}

function setSelectionInSliderGroups(sliderGroups, payload) {
  return sliderGroups.map((group) => {
    if (group.id === payload.groupID) {
      group = setSelectionInGroup(group, payload);
    }
    return group;
  });
}

function setSelectionInGroup(group, payload) {
  return {
    ...group,
    sliders: setSelectionInSliders(group.sliders, payload),
    updated: true,
  };
}

function setSelectionInSliders(sliders, payload) {
  return sliders.map((slider) => {
    if (slider.id === payload.sliderID) {
      slider = setSelectionInSlider(slider, payload);
    }
    return slider;
  });
}

function setSelectionInSlider(slider, payload) {
  return {
    ...slider,
    current: payload.current,
  };
}
